import type { FormRecord, SubmissionRecord, FormSubmission } from './types';

export function adaptFormRecord(raw: unknown): FormRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<FormRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    site_id: String(data.site_id || ''),
    title: String(data.title || 'Untitled Form'),
    form_schema_json: data.form_schema_json && typeof data.form_schema_json === 'object' ? data.form_schema_json : {},
    target_host_action: String(data.target_host_action || 'coach.crm.lead_capture'),
    created_at: String(data.created_at || ''),
  };
}

export function adaptFormRecordList(raw: unknown): FormRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptFormRecord);
}

export function adaptSubmissionRecord(raw: unknown): SubmissionRecord {
  const data = (raw && typeof raw === 'object' ? raw : {}) as Partial<SubmissionRecord>;
  return {
    id: String(data.id || ''),
    tenant_id: String(data.tenant_id || ''),
    form_id: String(data.form_id || ''),
    idempotency_key: String(data.idempotency_key || ''),
    payload_json: data.payload_json && typeof data.payload_json === 'object' ? data.payload_json : {},
    sync_status: String(data.sync_status || 'pending'),
    host_record_id: data.host_record_id ? String(data.host_record_id) : null,
    created_at: String(data.created_at || ''),
  };
}

export function adaptSubmissionRecordList(raw: unknown): SubmissionRecord[] {
  if (!Array.isArray(raw)) return [];
  return raw.map(adaptSubmissionRecord);
}

export function adaptFormSubmission(rec: SubmissionRecord): FormSubmission {
  return {
    id: rec.id,
    formId: rec.form_id,
    idempotencyKey: rec.idempotency_key,
    payload: rec.payload_json,
    syncStatus: (rec.sync_status === 'synced' || rec.sync_status === 'failed') ? rec.sync_status : 'pending',
    createdAt: rec.created_at,
  };
}

export function adaptFormSubmissionList(raw: unknown): FormSubmission[] {
  return adaptSubmissionRecordList(raw).map(adaptFormSubmission);
}
